module.exports = __webpack_public_path__ + "assets/cf80ee5cf2a3fdcd76d0e62c6ad5a2c4.png";